var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Heading from "@widgets/heading/heading";
import React, { useEffect, useState } from "react";
import Image from "@widgets/image/image";
import { Modal } from "@assets/tsx/modal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import Turnstile from "react-turnstile";
import { EmailSubmit } from '@assets/tsx/emailSubmit';
import { AlertCard } from "@assets/tsx/alert";
import { isValidEmail } from "@assets/ts/emailValidate";
import { useI18n } from "@wordpress/react-i18n";
export default function Newsletter({ _id, title, image, placeholder, submit_url, prefetch, background, description, button_background }) {
    const { __ } = useI18n();
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [token, setToken] = useState(null);
    const [error, setError] = useState(null);
    const [alert, setAlert] = useState(null);
    const [checked, setChecked] = useState(() => {
        const categories = (prefetch === null || prefetch === void 0 ? void 0 : prefetch.segments) || [];
        if (!categories.length)
            return null;
        const boxes = categories.map(({ id, value }) => {
            return {
                label: value,
                alias: id,
                checked: false
            };
        });
        return boxes;
    });
    useEffect(() => {
        if (!error)
            return;
        if (isValidEmail(email)) {
            setError(null);
        }
    }, [email]);
    const onSubmit = (ev) => __awaiter(this, void 0, void 0, function* () {
        ev.preventDefault();
        if (!email) {
            setError(__("Įveskite el. pašto adresą", 'ltg-widgets'));
            return;
        }
        if (!isValidEmail(email)) {
            console.log(email);
            setError(__("Netinkamas el. pašto formatas", 'ltg-widgets'));
            return;
        }
        setError(null);
        if (!token)
            return;
        if (!submit_url)
            return;
        setSubmitting(true);
        const formData = new FormData();
        checked === null || checked === void 0 ? void 0 : checked.map((cb) => {
            if (!cb.checked)
                return;
            formData.append('checked[]', cb.alias);
        });
        formData.append('email', email);
        formData.append('cf-turnstile-response', token);
        const response = yield fetch(submit_url, {
            method: 'POST',
            body: formData
        }).then(res => { setSubmitting(false); return res.json(); });
        setAlert(response);
    });
    const onCloseAlert = () => { setAlert(null); setError(null); };
    return (React.createElement("div", { className: `ltg-newsletter-wrap${background ? ` bg-${background}` : ''}` },
        React.createElement("div", { className: "ltg-newsletter-form-wrap" },
            React.createElement(Heading, { text: title, content_type: "text", tag: "h2", underline: "yes", text_align: "left", underline_block: undefined, underline_offset: "0" }),
            description && React.createElement("div", { className: "ltg-newsletter-description", dangerouslySetInnerHTML: { __html: description } }),
            React.createElement("form", { onSubmit: onSubmit, noValidate: true },
                React.createElement("div", { className: "ltg-newsletter-checkbox-list" }, checked === null || checked === void 0 ? void 0 : checked.map((cb, i) => {
                    return (React.createElement("div", { className: "ltg-newsletter-checkbox-list-item", key: cb.label + i + checked.toString() },
                        React.createElement(Checkbox, { label: cb.label, checked: cb.alias === 'important' ? true : cb.checked, onChange: cb.alias !== 'important' ? (is_checked) => setChecked(prev => {
                                const clone_prev = [...prev];
                                clone_prev[i].checked = is_checked;
                                return clone_prev;
                            }) : null })));
                })),
                React.createElement("div", { className: "control-wrap" },
                    React.createElement(EmailSubmit, { id: _id, button_color: button_background, isSubmitting: submitting, text: __("Prenumeruoti", 'ltg-widgets'), value: email, placeholder: placeholder, error: error, onChange: (newVal) => {
                            setEmail(newVal);
                        } })),
                React.createElement("div", { style: { marginTop: 16, paddingLeft: 16 } },
                    React.createElement(Turnstile, { onVerify: (token) => { setToken(token); }, sitekey: prefetch === null || prefetch === void 0 ? void 0 : prefetch.turnstile_sitekey, autoResetOnExpire: true })))),
        image && (React.createElement("div", { className: "ltg-newsletter-img-wrap" },
            React.createElement(Image, { image: image, mask: "rounded" }))),
        React.createElement(Modal, { open: !!alert },
            React.createElement(OutsideAlerter, { callback: onCloseAlert },
                React.createElement(AlertCard, { status: alert === null || alert === void 0 ? void 0 : alert.status, title: alert === null || alert === void 0 ? void 0 : alert.title, message: alert === null || alert === void 0 ? void 0 : alert.message, onConfirm: onCloseAlert })))));
}
function Checkbox({ checked, onChange, label }) {
    return (React.createElement("label", { className: "ltg-checkbox" },
        React.createElement("input", { type: "checkbox", className: "sr-only", checked: checked, onChange: ({ target }) => { onChange && onChange(target.checked); } }),
        React.createElement("span", { className: `ltg-checkbox-check${checked ? " checkbox--active" : ""}`, "aria-hidden": "true" }),
        label));
}
